import { createSlice } from "@reduxjs/toolkit";
import { PLAY_PROMPT_DATA } from "../../../constants/reducer_names";

export const initialState = {
  promptLibraryData: [] as any,
  audioPlayerData: "" as any,
  isOpenAudioPlayer: false as any,
  playerName: "" as any,
  doPause: false as any,
  doPlay: false as any,
  promptType: "" as any,
  promptValue: "" as any,
};

const playpromptSlice = createSlice({
  name: PLAY_PROMPT_DATA,
  initialState,
  reducers: {
    promptData: (state, { payload }) => {
      state.promptLibraryData = payload.promptLibraryData;
    },
    createPromptData: (state, { payload }) => {
      state.promptLibraryData = [...state.promptLibraryData, payload.promptLibraryData];
    },
    doOpenAudioPlyer: (state, { payload }) => {
      state.audioPlayerData = payload.audioPlayerData;
      state.isOpenAudioPlayer = payload.isOpenAudioPlayer;
      state.playerName = payload.playerName;
      state.doPause = payload.doPause;
      state.doPlay = payload.doPlay;
      state.promptType = payload.promptType;
      state.promptValue = payload.promptValue;
    },
    updatevalue: (state, { payload }) => {
      state.promptLibraryData = payload.promptLibraryData;
      // state.promptLibraryData = [...state.promptLibraryData , payload.promptLibraryData]
    },

    reset: () => {},
  },
});

export const playPromptActions = playpromptSlice.actions;
export default playpromptSlice.reducer;
